module.exports = __webpack_public_path__ + "static/media/f5fb8f44-c0b2-4f7c-b3a6-c2538a5d3d4e_1.84bdeda48fd866459939091b88541a12.3a4f5f3e.png";